export default {
	// ── Strategy / step 1 ──────────────────────────────────────
	strategy_info_note: {
		en: 'Fixed-quota shows on a per-day schedule. You\'ll define exact time slots and per-cycle repeats in Step 2.',
		ru: 'Фиксированное количество показов по расписанию. Точные временные слоты и повторы в цикле задаются на Шаге 2.',
		ge: '', de: '', cn: '', pt: '',
	},
	hero_hint_back_to_auction: {
		en: 'Change strategy back to Auction on Step 1.',
		ru: 'Сменить стратегию обратно на «Аукцион» можно на Шаге 1.',
		ge: '', de: '', cn: '', pt: '',
	},

	// ── Timing rules ───────────────────────────────────────────
	timing_rules: {
		en: 'Timing Rules',
		ru: 'Расписание показов',
		ge: '', de: '', cn: '', pt: '',
	},
	timing_rules_hint: {
		en: 'Define exactly when your ad airs. For each active day, add one or more time ranges and the number of repeats per cycle.',
		ru: 'Задайте, когда именно показывается реклама. Для каждого активного дня добавьте один или несколько временных диапазонов и количество повторов в цикле.',
		ge: '', de: '', cn: '', pt: '',
	},
	add_time_range: {
		en: 'Add time range',
		ru: 'Добавить диапазон',
		ge: '', de: '', cn: '', pt: '',
	},
	repeats: {
		en: 'repeats',
		ru: 'повторов',
		ge: '', de: '', cn: '', pt: '',
	},
	repeats_per_cycle: {
		en: 'repeats/cycle',
		ru: 'повторов/цикл',
		ge: '', de: '', cn: '', pt: '',
	},
	ranges_label: {
		en: 'ranges',
		ru: 'диапазонов',
		ge: '', de: '', cn: '', pt: '',
	},
	range_label_singular: {
		en: 'range',
		ru: 'диапазон',
		ge: '', de: '', cn: '', pt: '',
	},
	inactive_day: {
		en: 'Inactive',
		ru: 'Не активен',
		ge: '', de: '', cn: '', pt: '',
	},
	inactive_day_full: {
		en: 'Inactive — no airtime on this day',
		ru: 'Не активен — показов в этот день не будет',
		ge: '', de: '', cn: '', pt: '',
	},
	weekly_preview: {
		en: 'Weekly Preview',
		ru: 'Расписание на неделю',
		ge: '', de: '', cn: '', pt: '',
	},
	active_days_summary: {
		en: '{days} active days · {ranges} ranges',
		ru: 'Активных дней: {days} · Диапазонов: {ranges}',
		ge: '', de: '', cn: '', pt: '',
	},
	preview_help: {
		en: 'Active hourly slots based on the time ranges above. Hover a cell to see the exact range and repeat count.',
		ru: 'Активные часовые слоты на основе диапазонов выше. Наведите на ячейку, чтобы увидеть точный диапазон и количество повторов.',
		ge: '', de: '', cn: '', pt: '',
	},
	weekday_mon: { en: 'Monday',    ru: 'Понедельник', ge: '', de: '', cn: '', pt: '' },
	weekday_tue: { en: 'Tuesday',   ru: 'Вторник',     ge: '', de: '', cn: '', pt: '' },
	weekday_wed: { en: 'Wednesday', ru: 'Среда',       ge: '', de: '', cn: '', pt: '' },
	weekday_thu: { en: 'Thursday',  ru: 'Четверг',     ge: '', de: '', cn: '', pt: '' },
	weekday_fri: { en: 'Friday',    ru: 'Пятница',     ge: '', de: '', cn: '', pt: '' },
	weekday_sat: { en: 'Saturday',  ru: 'Суббота',     ge: '', de: '', cn: '', pt: '' },
	weekday_sun: { en: 'Sunday',    ru: 'Воскресенье', ge: '', de: '', cn: '', pt: '' },
	weekday_short_mon: { en: 'Mon', ru: 'Пн', ge: '', de: '', cn: '', pt: '' },
	weekday_short_tue: { en: 'Tue', ru: 'Вт', ge: '', de: '', cn: '', pt: '' },
	weekday_short_wed: { en: 'Wed', ru: 'Ср', ge: '', de: '', cn: '', pt: '' },
	weekday_short_thu: { en: 'Thu', ru: 'Чт', ge: '', de: '', cn: '', pt: '' },
	weekday_short_fri: { en: 'Fri', ru: 'Пт', ge: '', de: '', cn: '', pt: '' },
	weekday_short_sat: { en: 'Sat', ru: 'Сб', ge: '', de: '', cn: '', pt: '' },
	weekday_short_sun: { en: 'Sun', ru: 'Вс', ge: '', de: '', cn: '', pt: '' },

	// ── Playback rules ─────────────────────────────────────────
	playback_rules: {
		en: 'Playback Rules',
		ru: 'Правила воспроизведения',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_rules_hint: {
		en: 'Control how creatives in this campaign rotate during a single show.',
		ru: 'Управляйте, как креативы кампании ротируются в рамках одного показа.',
		ge: '', de: '', cn: '', pt: '',
	},
	content_items_per_show: {
		en: 'Content items per show',
		ru: 'Креативов за один показ',
		ge: '', de: '', cn: '', pt: '',
	},
	content_items_per_show_hint: {
		en: 'How many creatives from your playlist play within a single guaranteed show.',
		ru: 'Сколько креативов из плейлиста проигрывается в одном гарантированном показе.',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_order: {
		en: 'Playback order',
		ru: 'Порядок показа',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_order_hint: {
		en: 'For multi-creative campaigns. With a single creative this has no effect.',
		ru: 'Применимо для кампаний с несколькими креативами. Для одного креатива не имеет значения.',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_order_sequential: {
		en: 'Sequential — by playlist order',
		ru: 'Последовательно — по порядку плейлиста',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_order_random: {
		en: 'Random',
		ru: 'Случайный',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_explainer_title: {
		en: 'How a show plays',
		ru: 'Как проигрывается показ',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_explainer_intro: {
		en: 'With <b>3 creatives</b>, <b>content items per show = 2</b>, in <b>Sequential</b> order:',
		ru: 'При <b>3 креативах</b>, <b>2 креативах за показ</b> и <b>последовательном</b> порядке:',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_explainer_cycle1: {
		en: 'Cycle 1 — first show:',
		ru: 'Цикл 1 — первый показ:',
		ge: '', de: '', cn: '', pt: '',
	},
	playback_explainer_cycle2: {
		en: 'Cycle 2 picks up where it left off:',
		ru: 'Цикл 2 продолжается с того же места:',
		ge: '', de: '', cn: '', pt: '',
	},
	book_without_content: {
		en: 'Book without content',
		ru: 'Бронирование без контента',
		ge: '', de: '', cn: '', pt: '',
	},
	book_without_content_hint: {
		en: 'Reserve airtime now and upload creatives later (skips Step 3 / Creatives).',
		ru: 'Зарезервируйте эфирное время сейчас и загрузите креативы позже (Шаг 3 / Креативы будет пропущен).',
		ge: '', de: '', cn: '', pt: '',
	},

	// ── Step 2 / Spot duration & schedule ──────────────────────
	spot_duration: {
		en: 'Spot Duration',
		ru: 'Длительность ролика',
		ge: '', de: '', cn: '', pt: '',
	},
	spot_duration_hint: {
		en: 'Length of a single playback. Frequency Limit doesn\'t apply — repeats are defined per timing range.',
		ru: 'Длительность одного показа. Frequency Limit не применяется — повторы задаются в каждом диапазоне расписания.',
		ge: '', de: '', cn: '', pt: '',
	},
	spot_duration_help: {
		en: 'Required for guaranteed campaigns. Range 1–300 seconds.',
		ru: 'Обязательно для гарантированных кампаний. Диапазон 1–300 секунд.',
		ge: '', de: '', cn: '', pt: '',
	},
	schedule_replaced_by_timing_rules: {
		en: 'The "active days of week" pill row from Auction is replaced by per-day timing rules below.',
		ru: 'Выбор активных дней недели из «Аукциона» заменён правилами расписания по дням ниже.',
		ge: '', de: '', cn: '', pt: '',
	},

	// ── Campaign summary ───────────────────────────────────────
	summary_active_days_per_week: {
		en: 'Active Days/Week',
		ru: 'Активных дней/нед.',
		ge: '', de: '', cn: '', pt: '',
	},
	summary_time_ranges: {
		en: 'Time Ranges',
		ru: 'Диапазонов',
		ge: '', de: '', cn: '', pt: '',
	},
	summary_planned_shows: {
		en: 'Planned Shows',
		ru: 'Плановых показов',
		ge: '', de: '', cn: '', pt: '',
	},
	summary_reserved_only: {
		en: 'Reserved Only',
		ru: 'Только резерв',
		ge: '', de: '', cn: '', pt: '',
	},
	summary_reserved_yes: {
		en: 'Yes — content later',
		ru: 'Да — контент позже',
		ge: '', de: '', cn: '', pt: '',
	},
	summary_reserved_no: {
		en: 'No',
		ru: 'Нет',
		ge: '', de: '', cn: '', pt: '',
	},
};
